export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0026s_0000_Black-&-White-12.b2b407f1.png";